import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DrawerComponent } from 'common-ui';
import { NavigationListComponent } from 'navigation-ui';
import { SecondaryNavigationFrameRenderTargetComponent } from './renter-targets/secondary-navigation-frame-render-target.component';
import { SecondaryNavigationRenderTargetComponent } from './renter-targets/secondary-navigation-render-target.component';
import { SecondaryNavigationMenuComponentStore } from './secondary-navigation-menu.store';

@Component({
  selector: 'ideal-secondary-navigation-menu',
  standalone: true,
  imports: [
    DrawerComponent,
    SecondaryNavigationRenderTargetComponent,
    SecondaryNavigationFrameRenderTargetComponent,
    NavigationListComponent,
  ],
  templateUrl: './secondary-navigation-menu.component.html',
  styleUrl: './secondary-navigation-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecondaryNavigationMenuComponent {
  // Provided by NavigationSideMenuComponent, which shares it with its menu click handling.
  protected navStore = inject(SecondaryNavigationMenuComponentStore);
}
